"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var BrandsSmsCfgRestrictionsListCtl = /** @class */ (function (_super) {
    __extends(BrandsSmsCfgRestrictionsListCtl, _super);
    function BrandsSmsCfgRestrictionsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_sms_action_type_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.sms_action_type_code; });
        _this.dk_sms_action_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.sms_action_type_title; });
        _this.dk_completed_attempts_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.completed_attempts_count; });
        _this.dk_block_by_minutes = UIUtils_1.UIUtils.IProp2Str(function (o) { o.block_by_minutes; });
        _this.dk_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_locked; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this._errDialog = errDialog;
        return _this;
    }
    BrandsSmsCfgRestrictionsListCtl.prototype.ResetData = function () {
        this.DATA = {
            total: 0,
            data: []
        };
    };
    BrandsSmsCfgRestrictionsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        return null;
    };
    BrandsSmsCfgRestrictionsListCtl.prototype.LoadData = function (brandId, onDone) {
        var _this = this;
        webAApi_1.ListSmsConfigRestrictionsByBrandIdGet.exec({ brand_id: brandId }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    sms_action_type_code: resp.list[i].sms_action_type_code,
                    sms_action_type_title: resp.list[i].sms_action_type_title,
                    completed_attempts_count: resp.list[i].completed_attempts_count,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    block_by_minutes: resp.list[i].block_by_minutes,
                    is_locked: resp.list[i].is_locked
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandsSmsCfgRestrictionsListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddSmsConfigRestriction.exec({
            data: {
                brand_id: data.brand_id,
                sms_action_type_code: data.sms_action_type_code,
                completed_attempts_count: data.completed_attempts_count,
                block_by_minutes: data.block_by_minutes,
                is_locked: data.is_locked
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                sms_action_type_code: data.sms_action_type_code,
                sms_action_type_title: resp.sms_action_type_title,
                block_by_minutes: data.block_by_minutes,
                date_changed2: moment(resp.date_changed_uts_ms).utc(false),
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                completed_attempts_count: data.completed_attempts_count,
                is_locked: data.is_locked
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandsSmsCfgRestrictionsListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditSmsConfigRestriction.exec({
                data: {
                    brands_sms_timeout_restriction_id: data.key,
                    sms_action_type_code: data.sms_action_type_code,
                    completed_attempts_count: data.completed_attempts_count,
                    block_by_minutes: data.block_by_minutes,
                    is_locked: data.is_locked
                }
            }, function (resp) {
                _tmp.sms_action_type_code = data.sms_action_type_code;
                _tmp.sms_action_type_title = resp.sms_action_type_title;
                _tmp.completed_attempts_count = data.completed_attempts_count;
                _tmp.block_by_minutes = data.block_by_minutes;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.is_locked = data.is_locked;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BrandsSmsCfgRestrictionsListCtl.prototype.RemoveItem = function (accessKey) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === accessKey) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    BrandsSmsCfgRestrictionsListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteSmsConfigRestriction.exec({
                data: {
                    brands_sms_timeout_restriction_id: key,
                }
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BrandsSmsCfgRestrictionsListCtl.prototype.DoSetIsLocked = function (key, isLocked, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetSmsConfigRestrictionIsLocked.exec({
                data: {
                    brands_sms_timeout_restriction_id: key,
                    is_locked: isLocked
                }
            }, function (resp) {
                _tmp.is_locked = isLocked;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return BrandsSmsCfgRestrictionsListCtl;
}(BaseController_1.BaseController));
exports.BrandsSmsCfgRestrictionsListCtl = BrandsSmsCfgRestrictionsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ctl/BrandsSmsCfgRestrictionsListCtl.ts
// module id = 1041
// module chunks = 0